import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SubitemContainer, SubitemHeader } from "./styles";
import { CircleIndicator, FirstBar, SecondBar } from "../styles";
export var MenuSubitem = function (_a) {
    var subitem = _a.subitem, setModalItem = _a.setModalItem;
    var hasSubitems = subitem.subitems && subitem.subitems.length > 0;
    var pathToGo = subitem.overridePath
        ? subitem.overridePath
        : subitem.external
            ? "#"
            : subitem.path || "#";
    var hasSecondBar = (!subitem.isSubsubitem && hasSubitems) ||
        (subitem.isSubsubitem && !subitem.isLastSubsubitem);
    var handleClick = function () {
        if (subitem.external) {
            window.open(subitem.external, "_blank");
            return;
        }
        if (setModalItem) {
            setModalItem(null);
        }
    };
    return (_jsx(SubitemContainer, { id: "menu-item-".concat(subitem.id), children: _jsxs(SubitemHeader, { isSubsubitem: subitem.isSubsubitem, onClick: function () { return handleClick(); }, to: pathToGo, children: [subitem.isSubsubitem && _jsx(FirstBar, {}), (hasSubitems || subitem.isSubsubitem) && _jsx(CircleIndicator, {}), _jsx("span", { children: subitem.text }), hasSecondBar && _jsx(SecondBar, {})] }) }));
};
//# sourceMappingURL=index.js.map